export type { PaginationProps } from './pagination';
export { default } from './pagination';
